module.exports = __webpack_public_path__ + "img/five.2d963335.jpg";